import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

/**
 * Titre de page : met à jour le titre du document et reçoit le focus à l'arrivée, pour que
 * les lecteurs d'écran annoncent le changement d'écran d'une application monopage.
 */
export function PageHeading({
  children,
  documentTitle,
  className = 'app-title',
}: {
  children: ReactNode;
  documentTitle: string;
  className?: string;
}) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    document.title = `${documentTitle} · Apogée Visio`;
    ref.current?.focus({ preventScroll: true });
  }, [documentTitle]);
  return (
    <h1 ref={ref} tabIndex={-1} className={className}>
      {children}
    </h1>
  );
}
